<template>
  <footer>
    <v-layout class="menu-acces menubots" text-xs-right>
      <v-flex mr-5>
        <ul aria-label="recursos educativos">
          <li class="back-red" v-for="(bot, index) in listBots" @click.stop="showVideo(index)" :key="index">
            <button :id="'footer-bot-'+index" class="hvr-grow" :aria-label="bot.name" :class="('bot-'+index)"></button>
          </li>
        </ul>
      </v-flex>
    </v-layout>
    <v-dialog v-if="modalOne" v-model="modalOne" width="900" role="dialog" aria-label="glosario">
      <v-card class="pt-4 pb-4 pl-4 pr-4 align-center">
        <h3 class="title-peq">{{nameMod}}</h3>
        <div v-if="content.glosario">
          <ui-glosario :glosario="verglosario" ref="glosario"></ui-glosario>
        </div>
        <div v-if="content.bibliografia">
          <ui-bibliografia></ui-bibliografia>
        </div>
        <div v-if="content.creditos">
          <ui-creditos></ui-creditos>
        </div>
        <div v-if="content.videos">
          <ui-videos></ui-videos>
        </div>
        <div class="mt-3">
          <ui-button primary content="Cerrar contenido" aria="Cerrar contenido" @click.native="cerrarModal()"></ui-button>
        </div>
      </v-card>
    </v-dialog>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      modalOne: false,
      currentCont: 0,
      nameMod: '',
      verglosario:true,
      content: '',
      listBots: [
        {
          name: 'Glosario',
          clickBot: this.showVideo,
          content: { glosario: {} }
        },
        // {
        //   name: 'Bibliografía',
        //   clickBot: this.showVideo,
        //   content: { bibliografia: {} }
        // },
        // {
        //   name: 'Créditos',
        //   clickBot: this.showVideo,
        //   content: { creditos: {} }
        // },
        // { name: 'Vídeos', clickBot: this.showVideo, content: { videos: {} } }
      ]
    }
  },
  methods: {
    showVideo (event) {
      this.currentCont = event
      this.nameMod = this.listBots[event].name
      this.content = this.listBots[event].content
      this.modalOne = true
      this.verglosario = true
    },
    cerrarModal () {
      this.modalOne = false
      this.verglosario = false
      this.$refs.glosario.closeVideos();
      document.getElementById('footer-bot-' + this.currentCont).focus()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables.scss";

footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 5px;
}

.menu-acces {
  li {
    display: inline-block;
    button {
      background-image: url("../../assets/logos-icons/iconos-footer.png");
    }
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?1e108337